import { Component, Inject, OnInit, Optional } from '@angular/core';
import { PsDatosGeneralesService } from '../../../services/ps-datos-generales.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DateHelper } from '../../../models/NgDateCustomAdapter';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

@Component({
  selector: 'app-ps-revision-fin',
  templateUrl: './ps-revision-fin.component.html',
  styleUrls: ['./ps-revision-fin.component.scss']
})
export class PsRevisionFinComponent implements OnInit {

  idps: any;
  errorMessage: string = "";

  step: number = 1; // Controla la vista actual
  option: string | null = 'fechaExpedientes';
  expedienteDate: any;
  formattedExpedientDate: string;
  customDate: Date | null = null;
  isDisabledExpedienteDt: boolean = false;

  constructor(private _fb: FormBuilder, private _psDatosGenerales: PsDatosGeneralesService,
    @Optional() public dialogRef: MatDialogRef<PsRevisionFinComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dateHelper: DateHelper) { 
      if (data) {
        this.idps = data.idps;
      }
    }

  ngOnInit() {
    this.getFechaExpediente();
  }

  getFechaExpediente() {
    this._psDatosGenerales.getLastDttmExpediente(this.idps).subscribe((data: any) => {
      const result = data;
      
      if (result !== null && result.fechaInformeEntregado !== null) {
        this.expedienteDate = result.fechaInformeEntregado;
        this.formattedExpedientDate = moment(this.expedienteDate).format('DD/MM/YYYY');
      } else {
        this.isDisabledExpedienteDt = true;
        this.option = "otraFecha";
        this.formattedExpedientDate =  "No hay expedientes asignados o aún no han finalizado"
      }
      // this.expedienteDate = result !== null ? result.fechaInformeEntregado : "No hay expedientes asignados o aún no han finalizado";
    })
  }

  nextStep() {
    this.step = 2; // Cambiar al siguiente paso
  }

  cerrarRevision() {
    const result = this.option === 'fechaExpedientes' ? this.expedienteDate : this.customDate;

    if (!result) {
      this.errorMessage = "Para poder cerrar la revisión y finalizar el proyecto, es necesario seleccionar una fecha.";
      return null;
    }

    this.dialogRef.close({ completed: true, date: this.dateHelper.dateFormat_iso(result) });
  }

  close(cancelled: boolean) {
    this.dialogRef.close({ completed: !cancelled, date: null });
  }


}
